import React from 'react';

export default function LoadingIndicator() {
  return (
    <div className="la-ball-grid-beat la-2x">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
